/* Footer (PRO system) — sections/footer.liquid
   Menu columns are <details>: open and fixed from 750px up, collapsible
   accordions below. */
if (!customElements.get('cs-footer')) {
  customElements.define(
    'cs-footer',
    class CsFooter extends HTMLElement {
      connectedCallback() {
        this.columns = [...this.querySelectorAll('.cs-footer__column')];
        this.desktop = window.matchMedia('(min-width: 750px)');
        this.columns.forEach((column) => {
          column.querySelector('summary').addEventListener('click', (event) => {
            if (this.desktop.matches) event.preventDefault();
          });
        });
        this.update = () => this.columns.forEach((column) => (column.open = this.desktop.matches));
        this.desktop.addEventListener('change', this.update);
        this.update();
      }

      disconnectedCallback() {
        this.desktop?.removeEventListener('change', this.update);
      }
    }
  );
}
